import DynamicRoleDashboard from "./dashboards/DynamicRoleDashboard";

/** Shared home dashboard for every role (built from permissions menu). */
const ROLE_DASHBOARD = DynamicRoleDashboard;

/**
 * Role shells at /<basePath>/dashboard.
 * `dashboard` is always DynamicRoleDashboard; only redirects/extra routes differ per role.
 */
export const ROLE_SHELL_ROUTES = [
  {
    basePath: "admin",
    roleSlug: "admin",
    logoutPath: "/admin-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "notifications", to: "/app/notifications" },
      { from: "participants-list", to: "/app/tournaments/participants" },
      { from: "finance-payments", to: "/app/finance-payments" },
      { from: "cheque-masters", to: "/app/cheques/issues" },
      { from: "cheque-issues", to: "/app/cheques/issues" },
      { from: "cheque-collection", to: "/app/cheques/issues" },
      { from: "tournaments", to: "/app/tournaments/control" },
      { from: "donors-list", to: "/app/donor-support/donors" },
      { from: "donations-control", to: "/app/donor-support/donations" },
      { from: "donor-equipment-list", to: "/app/donor-support/equipment" },
      { from: "donor-certificates-control", to: "/app/donor-support/donations" },
      { from: "phone-calls", to: "/app/call-logs/control" },
      { from: "phone-call-logs-control", to: "/app/call-logs/control" },
      { from: "phone-call-logs", to: "/app/call-logs/control" },
      { from: "inward-outward-register", to: "/app/inward-outward/register" },
      { from: "maintenance-records-control", to: "/app/maintenance/control" },
      { from: "maintenance-records", to: "/app/maintenance/control" },
      { from: "tos-fros-control", to: "/app/to-and-fro/control" },
      { from: "tos-fros", to: "/app/to-and-fro/control" },
      { from: "visitor-control", to: "/app/visitors/control" },
      { from: "visitor-dashboard", to: "/app/visitors/control" },
      { from: "visitor-list", to: "/app/visitors/control" },
      { from: "visitors", to: "/app/visitors/control" },
      { from: "visitor-records", to: "/app/visitors/control" },
      { from: "visitor-purpose-list", to: "/app/visitors/control#visitor-control-masters" },
      { from: "visitor-id-proof-list", to: "/app/visitors/control#visitor-control-masters" },
      { from: "schedule-control", to: "/app/schedules/control" },
      { from: "schedules", to: "/app/schedules/control" },
      { from: "schedule-records", to: "/app/schedules/control" },
      { from: "schedule-type-list", to: "/app/schedules/control#schedule-control-masters" },
      { from: "schedule-status-list", to: "/app/schedules/control#schedule-control-masters" },
      { from: "priority-type-list", to: "/app/schedules/control#schedule-control-masters" },
      { from: "property-assets-control", to: "/app/property-assets/control" },
      { from: "properties", to: "/app/property-assets/control" },
    ],
  },
  {
    basePath: "volunteer",
    roleSlug: "volunteer",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "notifications", to: "/app/notifications" },
      { from: "add-donor", to: "/app/donor-support/donors" },
      { from: "collect-donations", to: "/app/donor-support/collect-donations" },
      { from: "donation-tracking", to: "/app/donor-support/donation-tracking" },
      { from: "member-registration", to: "/app/member-registrations" },
      { from: "tournament-registration", to: "/app/tournaments/register" },
      { from: "participants-list", to: "/app/tournaments/participants" },
      { from: "tournament-results", to: "/app/tournaments/results" },
      { from: "apply-memebership", to: "/app/memberships/apply" },
      { from: "memberships-list", to: "/app/memberships/list" },
    ],
  },
  {
    basePath: "office",
    roleSlug: "office",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "inwards-register", to: "/app/inward-outward/inwards" },
      { from: "outwards-register", to: "/app/inward-outward/outwards" },
      { from: "maintenance-records", to: "/app/maintenance" },
      { from: "maintanence-status", to: "/app/maintenance?tab=tracker" },
      { from: "cheques", to: "/app/cheques/issues" },
      { from: "cheque-issues", to: "/app/cheques/issues" },
      { from: "phone-call-logs", to: "/app/call-logs" },
      { from: "tos-fros", to: "/app/to-and-fro" },
      { from: "visitor-dashboard", to: "/app/visitors" },
      { from: "visitor-list", to: "/app/visitors" },
      { from: "visitors", to: "/app/visitors" },
      { from: "visitor-records", to: "/app/visitors" },
      { from: "visitor-registration", to: "/app/visitors" },
      { from: "visitor-register", to: "/app/visitors/register" },
      { from: "visitor-create", to: "/app/visitors/register" },
      { from: "visitor-purpose-list", to: "/app/visitors/control" },
      { from: "visitor-id-proof-list", to: "/app/visitors/control" },
      { from: "schedule-entry", to: "/app/schedules" },
      { from: "schedule-registration", to: "/app/schedules" },
      { from: "schedules-entry", to: "/app/schedules" },
      { from: "schedules", to: "/app/schedules" },
    ],
  },
  {
    basePath: "sub-admin",
    roleSlug: "sub-admin",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "add-donor", to: "/app/donor-support/donors" },
      { from: "collect-donations", to: "/app/donor-support/collect-donations" },
      { from: "donation-tracking", to: "/app/donor-support/donation-tracking" },
      { from: "tournaments-control", to: "/app/tournaments/control" },
      { from: "participants-list", to: "/app/tournaments/participants" },
      { from: "property-assets", to: "/app/property-assets" },
      { from: "properties", to: "/app/property-assets" },
    ],
  },
  {
    basePath: "students",
    roleSlug: "students",
    logoutPath: "/student-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "my-memberships", to: "/app/memberships/my-memberships" },
      { from: "my-tournaments", to: "/app/tournaments/my-tournaments" },
    ],
  },
  {
    basePath: "accountant",
    roleSlug: "accountant",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "accountant-memberships", to: "/app/memberships/payments" },
      { from: "membership-payments", to: "/app/memberships/payments" },
      { from: "tournament-payments", to: "/app/tournaments/payments" },
      { from: "Donations", to: "/app/donor-support/payments" },
      { from: "donations", to: "/app/donor-support/payments" },
      { from: "cheque-masters", to: "/app/cheques/issues" },
      { from: "cheque-issues", to: "/app/cheques/issues" },
      { from: "cheque-collection", to: "/app/cheques/issues" },
    ],
  },
  {
    basePath: "receptionist",
    roleSlug: "receptionist",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "phone-call-logs", to: "/app/call-logs" },
      { from: "visitor-dashboard", to: "/app/visitors" },
      { from: "visitor-list", to: "/app/visitors" },
      { from: "visitors", to: "/app/visitors" },
      { from: "visitor-records", to: "/app/visitors" },
      { from: "visitor-registration", to: "/app/visitors" },
      { from: "visitor-register", to: "/app/visitors/register" },
      { from: "visitor-create", to: "/app/visitors/register" },
    ],
  },
  {
    basePath: "recep",
    roleSlug: "recep",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "phone-call-logs", to: "/app/call-logs" },
      { from: "visitor-dashboard", to: "/app/visitors" },
      { from: "visitor-list", to: "/app/visitors" },
      { from: "visitors", to: "/app/visitors" },
      { from: "visitor-records", to: "/app/visitors" },
      { from: "visitor-registration", to: "/app/visitors" },
      { from: "visitor-register", to: "/app/visitors/register" },
      { from: "visitor-create", to: "/app/visitors/register" },
    ],
  },
  {
    basePath: "donor",
    roleSlug: "donor",
    logoutPath: "/donor-login",
    dashboard: ROLE_DASHBOARD,
    redirects: [
      { from: "notifications", to: "/app/notifications" },
      { from: "donation-history", to: "/app/donor-portal/donation-history" },
      { from: "donation-tracking", to: "/app/donor-portal/donation-tracking" },
    ],
  },
  {
    basePath: "hostel-guest",
    roleSlug: "hostel-guest",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
  {
    basePath: "hostel-staff",
    roleSlug: "hostel-staff",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
  {
    basePath: "hostel-receptionist",
    roleSlug: "hostel-receptionist",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
  {
    basePath: "hostel-manager",
    roleSlug: "hostel-manager",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
  {
    basePath: "librarian",
    roleSlug: "librarian",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
  {
    basePath: "library-admin",
    roleSlug: "library-admin",
    logoutPath: "/user-login",
    dashboard: ROLE_DASHBOARD,
  },
];

/** basePath values that have a dedicated shell (redirects / extra routes). */
export const ROLE_SHELL_BASE_PATHS = new Set(
  ROLE_SHELL_ROUTES.map((r) => r.basePath),
);
